import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { SettingsService } from '../../core/settings/settings.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Globals } from '../../globals'
import { ActivatedRoute, Router } from '@angular/router';
import { User } from '../../routes/users/user';
import { UserService } from '../../services/user.service';
import { DataService } from '../../services/data.service';
import { HttpTokenService, SignInData } from '../../services/http.token.service';
import { MessageService } from '../../services/message.service';
import { AlertService } from '../../_alert';
import { GlobalErrorHandlerService } from '../../services/global-error.service';
import { LoaderService } from '../../services/loader.service';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  private userType: any = [
    { name: 'patient', path: '#' },
    { name: 'doctor', path: '/enterprise/home/dashboard' },
    { name: 'practice', path: '/enterprise/home/dashboard' },
    { name: 'group', path: '/enterprise' },
    { name: 'enterprise', path: '/enterprise/home/dashboard' }
  ];

  show_error = false;
  isLoggingIn = false;
  account_not_verified = false;
  valForm: FormGroup;
  public _signInData: SignInData = <SignInData>{};
  public _output: any;
  user: User = new User();
  @Input() show;
  @Input() isEmbedded: boolean = false;
  @Output() login_popup_closed: EventEmitter<boolean> = new EventEmitter<boolean>();
  browser = <any>navigator;
  public unverified_hashid;

  // Policy modal
  showPolicyModal = false;
  policyModalTitle = '';
  policyContent: SafeHtml = '';
  policyLoading = false;
  policyError = false;
  policyFallbackUrl = '';

  private readonly WP_API = 'https://brown-koala-400827.hostingersite.com/wp-json/wp/v2/pages';
  private readonly TERMS_SLUG = 'terms-of-use';
  private readonly PRIVACY_SLUG = 'privacy-policy';
  private readonly TERMS_URL = 'https://brown-koala-400827.hostingersite.com/terms-of-use/';
  private readonly PRIVACY_URL = 'https://brown-koala-400827.hostingersite.com/privacy-policy/';


  constructor(public settings: SettingsService, fb: FormBuilder, public alertService: AlertService,
              private _tokenService: HttpTokenService, private globals: Globals,
              private router: Router, public _userService: UserService, private data_service: DataService,
              private route: ActivatedRoute, private _message_service: MessageService,
              public globalErrorHandlerService: GlobalErrorHandlerService,
              public loaderService: LoaderService,
              private sanitizer: DomSanitizer,
              private http: HttpClient) {


    this.valForm = fb.group({
      'email': [null, Validators.required],
      'password': [null, Validators.required]
    });
  }

  submitForm($ev, value: any) {
    $ev.preventDefault();
    for (let c in this.valForm.controls) {
      this.valForm.controls[c].markAsTouched();
    }
    if (this.valForm.valid) {
      this._output = null;
      this._signInData.email = this._signInData.email.toLowerCase();
      this.isLoggingIn = true;
      this._tokenService.signIn(this._signInData).subscribe(
        res => {
          this.isLoggingIn = false;
          this._userService.user_email_verified_successfully = false;
          this._userService.force_close = false;
          this.data_service.mark_user_dirty();
          this._signInData = <SignInData>{};
          this._output = res;
          this._message_service.set_notifications();

          let redirect_to_role = this.userType.filter(item => (item.name === this._tokenService.currentUserData['userType']));
          let user = this.user.load_from_json(this._tokenService.currentUserData);
          this.trigger_login_close();
          console.log('check redirect', user);
          if (user.extra['redirect_to_change_password']) {
            localStorage.removeItem('sessionExpiredRoute');
            this.router.navigate(['change-password'], { queryParams: { hippa: true } });
            return false;
          }

          // Check if this is a Practice user logging in after session expiry
          const sessionExpiredRoute = localStorage.getItem('sessionExpiredRoute');
          if (user.userType === 'practice' && sessionExpiredRoute && sessionExpiredRoute !== '/' && sessionExpiredRoute !== '/home') {
            // Clear the stored route
            localStorage.removeItem('sessionExpiredRoute');
            // Navigate to the saved route
            this.router.navigateByUrl(sessionExpiredRoute);
            return false;
          }

          // not logged in so redirect to login page with the return url and return false
          let re_director = (redirect_to_role && redirect_to_role[0]) ? redirect_to_role[0].path : 'home';
          if (re_director != '#') {
            this.router.navigateByUrl(re_director);
            return false;
          } else {
            this.router.navigateByUrl('/patients/' + user.profileable_id);
            return false;
          }
        }, error => {
          this.isLoggingIn = false;
          if (error && error.status === 401) {
            this.setTimeOutFailsMessage();
          }
          if (error && error.status === 409) {
            this.setTimeOutFailsMessageInactiveUser();
          }
          if (error && error.status === 408) {
            this.account_not_verified = true;
            this._output = error.error.errors[0];
            this.unverified_hashid = error.error.id;
          }
        }
      );
    }
  }
  setTimeOutFailsMessage(): any {
    this.show_error = true;
    this._output = 'Invalid email or password.';
    setTimeout(() => {
      this._output = null;
      this.show_error = false;
    }, 3000)
  }

  setTimeOutFailsMessageInactiveUser(): any {
    this.show_error = true;
    this._output = 'User is inactive/blocked. Please contact our customer support to activate/unblock this user.';
    setTimeout(() => {
      this._output = null;
      this.show_error = false;
    }, 3000)
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      if (params['email']) {
        this._signInData.email = params['email'];
      }
    });
    // if (this._userService.current_user) {
    //   this.router.navigate(['home']);
    // }
  }
  trigger_login_close() {
    this._userService.toggleLogin();
  }

  resendVerificationEmail() {
    if (this.unverified_hashid) {
      this.loaderService.show();
      this._userService.resendVerificationEmail(this.unverified_hashid).then(response => {
        this.unverified_hashid = undefined;
        this._output = null;
        this.account_not_verified = false;
        this.loaderService.hide();
        this.alertService.success('eMail has been sent successfully', this.alertService.options);
      }).catch(res => {
        this.loaderService.hide();
        this.globalErrorHandlerService.error = res.error.error;
      })
    }
  }

  openPolicyModal(type: 'terms' | 'privacy') {
    const isTerms = type === 'terms';
    this.policyModalTitle = isTerms ? 'Terms of Use' : 'Privacy Policy';
    this.policyFallbackUrl = isTerms ? this.TERMS_URL : this.PRIVACY_URL;
    const slug = isTerms ? this.TERMS_SLUG : this.PRIVACY_SLUG;

    this.policyContent = '';
    this.policyError = false;
    this.policyLoading = true;
    this.showPolicyModal = true;

    this.http.get<any[]>(`${this.WP_API}?slug=${slug}`).subscribe({
      next: (pages) => {
        this.policyLoading = false;
        if (pages && pages.length > 0) {
          const rawHtml = pages[0].content.rendered;
          // Strip WordPress/Divi shortcodes like [et_pb_section ...] and [/et_pb_text]
          const cleanHtml = rawHtml
            .replace(/\[[^\]]*\]/g, '')   // remove all [shortcode] patterns
            .replace(/^\s*[\r\n]/gm, '')  // remove blank lines left by shortcodes
            .trim();
          this.policyContent = this.sanitizer.bypassSecurityTrustHtml(cleanHtml);
        } else {
          this.policyError = true;
        }
      },
      error: () => {
        this.policyLoading = false;
        this.policyError = true;
      }
    });
  }

  /**
   * Intercept clicks inside policy content.
   * If the link is a known policy page on our WordPress site,
   * open it inside the modal instead of navigating away.
   */
  handlePolicyContentClick(event: MouseEvent) {
    const anchor = (event.target as HTMLElement).closest('a') as HTMLAnchorElement;
    if (!anchor) { return; }
    const href = anchor.href || '';
    if (href.includes('privacy-policy')) {
      event.preventDefault();
      this.openPolicyModal('privacy');
    } else if (href.includes('terms-of-use')) {
      event.preventDefault();
      this.openPolicyModal('terms');
    } else if (href && !href.startsWith('#')) {
      // External links — open in new tab, don't leave the app
      event.preventDefault();
      window.open(href, '_blank');
    }
  }

  closePolicyModal() {
    this.showPolicyModal = false;
    this.policyContent = '';
  }
}
